import React, { useState, useEffect } from "react";
import "./ManageExtensions.css";
import { SidebarMenu } from "../Sidebar/SidebarMenu";
import { FirstAppHeader } from "../../Header/FirstAppHeader";
import { ButtonHover } from "../../ReuseableComp/ButtonHover";
import { UserExperienCard } from "../../ReuseableComp/UserExperienCard";
import { cardData } from "./cardData";

export const ManageExtensions = () => {
  console.log("arewegere?ManageExtensions")

  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch('https://jsonplaceholder.typicode.com/posts');
        const data = await response.json();
        const transformedData = transformData(data);
        setApiData(transformedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, []);


  const transformData = (data) => {
    return cardData;
  };

  return (
    <div className="overview_container">
      <div className="overviewContent">
        <div className="left">
          <SidebarMenu />
        </div>

        <div className="right">
          {/* <FirstAppHeader /> */}

          <div className="extension_data">
            <h1 className="heading">ManageExtensions</h1>
            <h4 className="subheading">User Experience</h4>

            <div className="card-container">
              {apiData.map((card, index) => (
                <UserExperienCard key={index} data={card} />
              ))}
            </div>

            <h4 className="subheading">User Engagement</h4>

            <div className="card-container">
              {apiData.map((card, index) => (
                <UserExperienCard key={index} data={card} />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="actionBtns">
        <ButtonHover text="Get started" />
        <ButtonHover text="Chat" />
      </div>
    </div>
  );
};

export default ManageExtensions;
